
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5.094V4.25a1.75 1.75 0 00-1.75-1.75H1.75A1.75 1.75 0 000 4.25v.844c0 .086.07.156.156.156h15.688c.086 0 .156-.07.156-.156zM0 6.406v5.344c0 .966.783 1.75 1.75 1.75h12.5A1.75 1.75 0 0016 11.75V6.406a.156.156 0 00-.156-.156H.156A.156.156 0 000 6.406zM4 10.5a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h.5a.5.5 0 01.5.5v.5z","fill":"#6C6C6C"}})])
          )
        }
      }
    